import { useMutation } from "@tanstack/react-query";
import FileDownload from 'js-file-download';
import { toast } from 'react-toastify';
import Api, { createFetchErrorMessage } from "utils/api/Api";

export const NoticeFile = ({file})=>{

    // 1.url을 가져오고
    const getFileUrlMutate = useMutation({
        mutationFn:()=>Api.get(`/api/notice/file/${file.id}/download`),
        onSuccess:(res)=>{
            downloadMutate.mutate(res.data.download);
        },
        onError:(err)=>{
            const errorData = createFetchErrorMessage(err, '다운로드 정보를 가져오는데 실패했습니다.');
            toast.error(errorData.message);
        }
    });

    // 2. url에서 파일을 다운로드하고 번잡한데?
    const downloadMutate = useMutation({
        mutationFn:(url)=>{
            return Api.get(url, {
                responseType:'blob'
            })
        },
        onSuccess:(res)=>{
            FileDownload(res.data, file.originalName);
        },
        onError:(err)=>{
            const errorData = createFetchErrorMessage(err, '파일다운로드에 실패했습니다.');
            toast.error(errorData.message);
        }
    });

    const onDownload = ()=>{
        if(getFileUrlMutate.isPending) return;
        if(downloadMutate.isPending)return;
        getFileUrlMutate.mutate()
    }

    return (
        <button className="file"  key={file.id} onClick={onDownload}>
            {file.originalName}
        </button>
    );
};